<template>
    <div :class="{ 'custom-checkbox': true, 'has-errors': errors.has( name ) }">
        <input
            type="checkbox"
            :checked="checked"
            :id="name"
            :name="name"

            @change="onChange"
            v-validate="rules[ name ]"
            data-vv-validate-on="input"
            :tabindex="tabindex" />

        <div class="indicator"></div>
        <label :for="name">
            <!-- <div :class="{ 'indicator': true, 'checked': checked }"></div> -->

            <slot></slot>
        </label>

        <span class="error">{{ errors.first( name ) }}</span>
    </div>
</template>

<style lang="scss" scoped>
    .custom-checkbox{
        position:relative;
    }

    input, label{
        display:inline-block;
    }

    span.error{
        display:block;
    }
</style>

<script>
    import Vue from 'vue';
    import { rules } from '@/app/config';
    import { tracking } from '@/app/mixins';

    export default {
        inject: [ '$validator' ],

        mixins: [ tracking ],

        model: {
            prop: 'checked',
            event: 'change'
        },

        props: {
            checked: {
                type: Boolean,
                default: false
            },

            name: {
                type: String,
                default: 'checkbox'
            },

            tabindex: {
                type: String,
                default: ''
            }
        },

        data()
        {
            return {
                rules: rules
            };
        },

        methods: {
            onChange( e )
            {
                this.$emit( 'change', e.target.checked );

                Vue.nextTick( () =>
                {
                    this.trackEvent( 'Klik op checkbox', 'Funnel events', ( e.target.checked ? 'Aangevinkt' : 'Uitgevinkt' ) + ' - ' + 'Ja, ik ontvang graag per e-mail interessante acties en aanbiedingen van Lotto.' );
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/form-elements/CustomCheckbox.vue